import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import '../../assets/styles/bootstrap.min.css'
import ChatWidget from "../ChatBot/ChatWidget";

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      maxHeight: '100vh',
      overflow: 'hidden'
    }}>
      <Navbar />
      <main style={{
        flex: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto'
      }}>
        {children}

      </main>

        {/* Floating Chat Bot */}
        {/* <ChatWidget /> */}
      <Footer />
    </div>
  );
};

export default MainLayout;
